import HeaderComponent from "src/Components/Header";
import FooterComponent from "src/Components/Footer";
import BookingHistoryLayout from "src/Layouts/BookingHistory";

const BookingHistoryPage = () => {
  return (
    <>
      <div className="min-h-full">
        <HeaderComponent />
        <main>
          <div className="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
            <BookingHistoryLayout />
          </div>
        </main>
        <FooterComponent />
      </div>
    </>
  );
};

export default BookingHistoryPage;
